import { LogSafeValue } from './log-safe-value.type';

export class LogSafeValueImpl implements LogSafeValue {
  constructor(public value: unknown) {}
}
